const o = (r) => {
  if (!r)
    return 0;
  const t = parseFloat(r);
  return !isNaN(t) && t > 0 ? t : 0;
}, e = (r, t) => !r && o(t) > 0;
export {
  o as getValidCityTaxAmount,
  e as shouldShowCityTaxItem
};
